import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import ButtonLink from "../buttonLink/ButtonLink";
import { useIntlTranslate } from "../../hooks";

import "./List.scss";

export const List = ({
  className,
  title,
  clearText,
  onClear,
  placeholder,
  children,
}) => {
  const translate = useIntlTranslate();
  const isEmpty = React.Children.count(children) === 0;
  const ariaLabel = translate("aria_remove_all", { list: title });

  return (
    <div className={classnames("list", className)}>
      <div className="list-header">
        <div className="list-header__title">{title}</div>
        <ButtonLink onClick={onClear} disabled={isEmpty} aria-label={ariaLabel}>
          {clearText}
        </ButtonLink>
      </div>
      <ul className="list-content">
        {isEmpty ? (
          <li className="list-content__placeholder">{placeholder}</li>
        ) : (
          children
        )}
      </ul>
    </div>
  );
};

List.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  clearText: PropTypes.node.isRequired,
  onClear: PropTypes.func.isRequired,
  placeholder: PropTypes.node.isRequired,
};
